import {
  defaultSystemCode,
  exists,
  ReserveSpecifyBranchCode,
  ReserveSpecifyBranchCodeFromJSON,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'
import {
  dateTimeToDateFormat,
  dateTimeToPlainFormat,
  dateToPlainFormat
} from '@/utils'

export interface Reserve {
  id: number
  rank: number
  userId: string
  name: string
  reserveRegistrationTime: string
  collectionId: number | null
  collectionNo: string
  preferredDate: string
  reserveExpiration: string
  reserveSpecifyBranchCodes: ReserveSpecifyBranchCode[]
  reserveSetId: number
  reserveSetRank: number
  reserveGroupId: number
  reserveRegistrationBranchCode: SystemCode
  forwardingBranchCode: SystemCode
  specifyCollectionId: string
  reserveStatus: SystemCode
  reserveNoticeAllowed: boolean
  displayMemo: string
  contactMethod: SystemCode
  revision: number
}

export function ReserveFromJSON(json: any): Reserve {
  return {
    id: exists(json, 'id') ? json.id : 0,
    rank: exists(json, 'rank') ? json.rank : 0,
    userId: exists(json, 'user_id') ? json.user_id : '',
    name: exists(json, 'name') ? json.name : '',
    reserveRegistrationTime: exists(json, 'reserve_registration_time')
      ? dateTimeToDateFormat(
          dateTimeToPlainFormat(json.reserve_registration_time)
        )
      : '',
    collectionId: exists(json, 'collection_id') ? json.collection_id : null,
    collectionNo: exists(json, 'collection_no') ? json.collection_no : '',
    preferredDate: exists(json, 'preferred_date')
      ? dateToPlainFormat(json.preferred_date)
      : '',
    reserveExpiration: exists(json, 'reserve_expiration')
      ? dateToPlainFormat(json.reserve_expiration)
      : '',
    reserveSpecifyBranchCodes: json.reserve_specify_branch_codes.map(
      ReserveSpecifyBranchCodeFromJSON
    ),
    reserveSetId: exists(json, 'reserve_set_id') ? json.reserve_set_id : 0,
    reserveSetRank: exists(json, 'reserve_set_rank')
      ? json.reserve_set_rank
      : 0,
    reserveGroupId: exists(json, 'reserve_group_id')
      ? json.reserve_group_id
      : 0,
    reserveRegistrationBranchCode: exists(
      json,
      'reserve_registration_branch_code'
    )
      ? SystemCodeFromJSON(json.reserve_registration_branch_code)
      : defaultSystemCode(),
    forwardingBranchCode: exists(json, 'forwarding_branch_code')
      ? SystemCodeFromJSON(json.forwarding_branch_code)
      : defaultSystemCode(),
    specifyCollectionId: exists(json, 'specify_collection_id')
      ? json.specify_collection_id
      : '',
    reserveStatus: exists(json, 'reserve_status')
      ? SystemCodeFromJSON(json.reserve_status)
      : defaultSystemCode(),
    reserveNoticeAllowed: exists(json, 'reserve_notice_allowed')
      ? json.reserve_notice_allowed
      : false,
    displayMemo: exists(json, 'display_memo') ? json.display_memo : '',
    contactMethod: exists(json, 'contact_method')
      ? SystemCodeFromJSON(json.contact_method)
      : defaultSystemCode(),
    revision: exists(json, 'revision') ? json.revision : 0
  }
}
